export default {
  install(): void {
    require('./app.scss');
  },
};
